import { type Common } from './common.js';
import { type ImportRow } from './models/outreachSync.js';
import { type ImportValidation } from './models/provider.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async importVerify(args: {
    feedId: string;
    practiceId: string;
    importRows: Record<string, string>[];
  }): Promise<Record<string, ImportValidation>[]> {
    const url = this.common.constructPath(`/outreach/sync/import/verify`);
    return await this.common.postJSON(url, args);
  }

  async import(args: {
    feedId: string;
    feedUploadId?: string;
    practiceId: string;
    importRows: ImportRow[];
    removeFeedItems?: boolean;
    appendFeedItems?: boolean;
  }) {
    const url = this.common.constructPath(`/outreach/sync/import`);
    return await this.common.postJSON(url, args);
  }
}
